import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Role\DeleteRoleController::deleteMethod
* @see app/Http/Controllers/Role/DeleteRoleController.php
* @route '/api/role/{role}'
*/
export const deleteMethod = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/role/{role}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Role\DeleteRoleController::deleteMethod
* @see app/Http/Controllers/Role/DeleteRoleController.php
* @route '/api/role/{role}'
*/
deleteMethod.url = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { role: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { role: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            role: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        role: typeof args.role === 'object'
        ? args.role.id
        : args.role,
    }

    return deleteMethod.definition.url
            .replace('{role}', parsedArgs.role.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Role\DeleteRoleController::deleteMethod
* @see app/Http/Controllers/Role/DeleteRoleController.php
* @route '/api/role/{role}'
*/
deleteMethod.delete = (args: { role: string | { id: string } } | [role: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Role\DeleteRoleController::undo
* @see app/Http/Controllers/Role/DeleteRoleController.php
* @route '/api/role/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: undo.url(args, options),
    method: 'delete',
})

undo.definition = {
    methods: ["delete"],
    url: '/api/role/undo-delete/{id}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Role\DeleteRoleController::undo
* @see app/Http/Controllers/Role/DeleteRoleController.php
* @route '/api/role/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Role\DeleteRoleController::undo
* @see app/Http/Controllers/Role/DeleteRoleController.php
* @route '/api/role/undo-delete/{id}'
*/
undo.delete = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: undo.url(args, options),
    method: 'delete',
})

const DeleteRoleController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteRoleController